import { isCampaignClosed, isCampaignRunning, type Campaign } from '@cvo/domain';

export function useCampaigns() {
  const campaigns = useState<Campaign[]>('campaigns', () => []);

  const activePublicCampaign = computed(() =>
    (campaigns.value ?? []).find(campaign =>
      !isCampaignClosed(campaign)
      && campaign.eligibility.some(entry => entry.type === 'PUBLIC')));

  /** Get the running campaign. If multiple campaigns are running simultaneously, return undefined. */
  const runningCampaign = computed(() => (campaigns.value.length === 1 ? campaigns.value.find(isCampaignRunning) : undefined));

  return {
    campaigns: readonly(campaigns),
    runningCampaign,
    activePublicCampaign,
  };
}
